define(["require", "exports", "tslib", "mobx", "../domain", "../services/AppConfigManager", "./PermitLicenseItemModel"], function (require, exports, tslib_1, mobx_1, domain_1, AppConfigManager_1, PermitLicenseItemModel_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PermitLicenseModel = void 0;
    class PermitLicenseModel {
        constructor(permit) {
            Object.defineProperty(this, "p", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApproveDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "IsApproveEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefuseDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "IsRefuseEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CancelDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "IsCancelEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApprovalCheckListItems", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AreAllApprovalConditionsChecked", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AdditionalConditions", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CanUserCaptureApprovalConditions", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CanUserCaptureApprovalComment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.p = permit;
            this.loadLicenseItems();
        }
        get ActiveLicenseStatus() {
            if (this.p.LicenseStatusReq) {
                return this.p.LicenseStatusReq;
            }
            else {
                return this.p.LicenseStatus;
            }
        }
        get IsPendingApprovalOrApproved() {
            return this.ActiveLicenseStatus == domain_1.PermitLicenseStatusDomain.PendingApproval || this.ActiveLicenseStatus == domain_1.PermitLicenseStatusDomain.Approved;
        }
        get IsPersistedStatePendingApprovalOrApproved() {
            return this.p.LicenseStatus == domain_1.PermitLicenseStatusDomain.PendingApproval || this.p.LicenseStatus == domain_1.PermitLicenseStatusDomain.Approved;
        }
        loadLicenseItems() {
            this.AdditionalConditions = [];
            this.ApprovalCheckListItems = [];
            let isApplicable = false;
            let selectedPermitLicenseItem = null;
            let config = AppConfigManager_1.AppConfigManager.InstanceSync;
            if (config.PermitLicenseItems) {
                for (let licenseItemDef of config.PermitLicenseItems) {
                    if (licenseItemDef.PermitType == -1 || licenseItemDef.PermitType == this.p.PermitType) {
                        isApplicable = this.isLicenseItemApplicableToPermit(licenseItemDef);
                        selectedPermitLicenseItem = this.getPermitLicenseItemByDefId(licenseItemDef.Id);
                        switch (licenseItemDef.ItemType) {
                            case domain_1.LicenseItemTypeDomain.Checklist:
                                this.ApprovalCheckListItems.push(new PermitLicenseItemModel_1.PermitLicenseItemModel(this.p, licenseItemDef, selectedPermitLicenseItem, isApplicable, licenseItemDef.IsActive == 1, this.licenseItemSelectionChanged.bind(this)));
                                break;
                            case domain_1.LicenseItemTypeDomain.AdditionalCondition:
                                this.AdditionalConditions.push(new PermitLicenseItemModel_1.PermitLicenseItemModel(this.p, licenseItemDef, selectedPermitLicenseItem, isApplicable, licenseItemDef.IsActive == 1, this.licenseItemSelectionChanged.bind(this)));
                                break;
                            default:
                                throw new Error("Permit License Item Type not supported");
                        }
                    }
                }
            }
            this.evaluateStatus();
        }
        licenseItemSelectionChanged() {
            this.deriveIfAllApprovalConditionsAreChecked();
        }
        updateLicenseItems() {
            console.log("updateLicenseItems");
            this.updateLicenseItemApplicability(this.ApprovalCheckListItems);
            this.updateLicenseItemApplicability(this.AdditionalConditions);
            this.evaluateStatus();
            this.ApprovalCheckListItems.forEach(x => console.log(x.LicenseDefinition.Id, x.LicenseDefinition.PermitType, x.LicenseDefinition.PermitSubtype, x.IsApplicable, x.IsSelected));
        }
        updateLicenseItemApplicability(permitLicenseItems) {
            for (let item of permitLicenseItems) {
                let isApplicable = this.isLicenseItemApplicableToPermit(item.LicenseDefinition);
                if (isApplicable) {
                    item.IsApplicable = true;
                }
                else {
                    item.IsApplicable = false;
                }
            }
        }
        isLicenseItemApplicableToPermit(licenseItemDef) {
            if (licenseItemDef.PermitType == -1) {
                return true;
            }
            else {
                if (licenseItemDef.PermitType == this.p.PermitType) {
                    if (licenseItemDef.PermitSubtype == -1) {
                        return true;
                    }
                    else {
                        if (this.p.PermitType == domain_1.PermitTypeDomain.TravelPermit) {
                            if (licenseItemDef.PermitSubtype == this.p.TravelPermit.TravelType) {
                                return true;
                            }
                        }
                        else if (this.p.PermitType == domain_1.PermitTypeDomain.GrazingPermit) {
                            if (licenseItemDef.PermitSubtype == this.p.GrazingPermit.GrazingType) {
                                return true;
                            }
                        }
                        else if (this.p.PermitType == domain_1.PermitTypeDomain.HarvestingPermit) {
                            return true;
                        }
                        else if (this.p.PermitType == domain_1.PermitTypeDomain.GrazingAuthority) {
                            return true;
                        }
                        else {
                            throw new Error("Unknown Permit Type");
                        }
                    }
                }
            }
            return false;
        }
        getPermitLicenseItemByDefId(licenseItemDefId) {
            var permitLicenseItem = null;
            for (let item of this.p.PermitLicItem) {
                if (item.LicenseItemId == licenseItemDefId) {
                    permitLicenseItem = item;
                    break;
                }
            }
            return permitLicenseItem;
        }
        getRelativePermitLicenseItem(PermitLicenseItem) {
            for (let x of this.ApprovalCheckListItems) {
                if (x.LicenseDefinition.Id != PermitLicenseItem.LicenseDefinition.Id && x.Description == PermitLicenseItem.Description) {
                    if (this.isLicenseItemApplicableToPermit(x.LicenseDefinition)) {
                        return x;
                    }
                }
            }
            return null;
        }
        evaluateStatus() {
            this.updateLicenseStatusUserFeedbackVariables();
            this.deriveIfAllApprovalConditionsAreChecked();
        }
        deriveIfAllApprovalConditionsAreChecked() {
            if (this.ApprovalCheckListItems && this.ApprovalCheckListItems.length > 0) {
                this.AreAllApprovalConditionsChecked = this.ApprovalCheckListItems.filter(x => x.IsApplicable).every(x => x.IsSelected);
            }
            else {
                this.AreAllApprovalConditionsChecked = true;
            }
            if (this.ActiveLicenseStatus == domain_1.PermitLicenseStatusDomain.Draft || this.ActiveLicenseStatus == domain_1.PermitLicenseStatusDomain.PendingApproval) {
                this.IsApproveEnabled = this.AreAllApprovalConditionsChecked;
            }
            console.log("deriveIfAllApprovalConditionsAreChecked", this.AreAllApprovalConditionsChecked);
        }
        approve() {
            switch (this.p.LicenseStatus) {
                case domain_1.PermitLicenseStatusDomain.Draft:
                    if (this.p.PermitType == domain_1.PermitTypeDomain.TravelPermit) {
                        this.setLicenseStatus(domain_1.PermitLicenseStatusDomain.Approved);
                    }
                    else {
                        this.setLicenseStatus(domain_1.PermitLicenseStatusDomain.Approved);
                    }
                    break;
                case domain_1.PermitLicenseStatusDomain.PendingApproval:
                    this.setLicenseStatus(domain_1.PermitLicenseStatusDomain.Approved);
                    break;
                case domain_1.PermitLicenseStatusDomain.Approved:
                    throw new Error("Can not promote a permit license that is in an Approved state");
                case domain_1.PermitLicenseStatusDomain.Cancelled:
                    throw new Error("Can not promote a permit license that is in a Cancelled state");
                case domain_1.PermitLicenseStatusDomain.Refused:
                    throw new Error("Can not promote a permit license that is in a Refused state");
                default:
                    throw new Error("Unknown Permit License Status");
            }
            this.updateLicenseStatusUserFeedbackVariables();
        }
        refuse() {
            if (this.p.LicenseStatus == domain_1.PermitLicenseStatusDomain.Draft || this.p.LicenseStatus == domain_1.PermitLicenseStatusDomain.PendingApproval) {
                this.setLicenseStatus(domain_1.PermitLicenseStatusDomain.Refused);
            }
            else if (this.p.LicenseStatus == domain_1.PermitLicenseStatusDomain.Cancelled) {
                this.setLicenseStatus(domain_1.PermitLicenseStatusDomain.Refused);
            }
            else {
                throw new Error(`A Permit License with a status of ${this.p.LicenseStatus} can not be refused`);
            }
            this.updateLicenseStatusUserFeedbackVariables();
        }
        cancel() {
            if (this.p.LicenseStatus == domain_1.PermitLicenseStatusDomain.Draft || this.p.LicenseStatus == domain_1.PermitLicenseStatusDomain.PendingApproval || this.p.LicenseStatus == domain_1.PermitLicenseStatusDomain.Approved) {
                this.setLicenseStatus(domain_1.PermitLicenseStatusDomain.Cancelled);
            }
            else {
                throw new Error(`A Permit License with a status of ${this.p.LicenseStatus} can not be cancelled.`);
            }
            this.updateLicenseStatusUserFeedbackVariables();
        }
        updateLicenseStatusUserFeedbackVariables() {
            this.deriveApprovalState();
            this.deriveCancelState();
            this.deriveRefuseState();
            this.derivePermittedApprovalActions();
        }
        deriveApprovalState() {
            switch (this.p.LicenseStatus) {
                case domain_1.PermitLicenseStatusDomain.Draft:
                    if (this.p.PermitType == domain_1.PermitTypeDomain.TravelPermit && (this.p.TravelPermit.TravelSegmentType == domain_1.TravelSegmentTypeDomain.MultipleShireTravelOriginatingShire || this.p.TravelPermit.TravelSegmentType == domain_1.TravelSegmentTypeDomain.MultipleShireTravelNonOriginatingShire)) {
                        this.ApproveDesc = "Request Approval";
                        this.IsApproveEnabled = true;
                    }
                    else {
                        this.ApproveDesc = "Approve";
                        this.IsApproveEnabled = true;
                    }
                    break;
                case domain_1.PermitLicenseStatusDomain.PendingApproval:
                    this.ApproveDesc = "Approve";
                    this.IsApproveEnabled = true;
                    break;
                case domain_1.PermitLicenseStatusDomain.Approved:
                    this.ApproveDesc = "Approved";
                    this.IsApproveEnabled = false;
                    break;
                case domain_1.PermitLicenseStatusDomain.Cancelled:
                    this.ApproveDesc = "Cancelled";
                    this.IsApproveEnabled = false;
                    break;
                case domain_1.PermitLicenseStatusDomain.Refused:
                    this.ApproveDesc = "Refused";
                    this.IsApproveEnabled = false;
                    break;
                default:
                    throw new Error("Unknown Permit License Status");
            }
        }
        deriveRefuseState() {
            this.RefuseDesc = "Refuse";
            switch (this.p.LicenseStatus) {
                case domain_1.PermitLicenseStatusDomain.Draft:
                    this.IsRefuseEnabled = true;
                    break;
                case domain_1.PermitLicenseStatusDomain.PendingApproval:
                    this.IsRefuseEnabled = true;
                    break;
                default:
                    this.IsRefuseEnabled = false;
            }
        }
        deriveCancelState() {
            this.CancelDesc = "Cancel";
            switch (this.p.LicenseStatus) {
                case domain_1.PermitLicenseStatusDomain.Draft:
                    this.IsCancelEnabled = true;
                    break;
                case domain_1.PermitLicenseStatusDomain.PendingApproval:
                    this.IsCancelEnabled = true;
                    break;
                case domain_1.PermitLicenseStatusDomain.Approved:
                    this.IsCancelEnabled = true;
                    break;
                default:
                    this.IsCancelEnabled = false;
            }
        }
        derivePermittedApprovalActions() {
            switch (this.p.LicenseStatus) {
                case domain_1.PermitLicenseStatusDomain.Draft:
                    this.CanUserCaptureApprovalConditions = true;
                    this.CanUserCaptureApprovalComment = true;
                    break;
                case domain_1.PermitLicenseStatusDomain.PendingApproval:
                    this.CanUserCaptureApprovalConditions = true;
                    this.CanUserCaptureApprovalComment = true;
                    break;
                case domain_1.PermitLicenseStatusDomain.Approved:
                    this.CanUserCaptureApprovalConditions = true;
                    this.CanUserCaptureApprovalComment = true;
                    break;
                case domain_1.PermitLicenseStatusDomain.Cancelled:
                    this.CanUserCaptureApprovalConditions = false;
                    this.CanUserCaptureApprovalComment = true;
                    break;
                case domain_1.PermitLicenseStatusDomain.Refused:
                    this.CanUserCaptureApprovalConditions = false;
                    this.CanUserCaptureApprovalComment = true;
                    break;
                default:
                    throw new Error("Unknown Permit License Status");
            }
        }
        restoreToOriginalStatus() {
            this.p.LicenseStatusReq = null;
            this.updateLicenseStatusUserFeedbackVariables();
        }
        setLicenseStatus(licenseStatus) {
            this.p.LicenseStatusReq = licenseStatus;
        }
    }
    exports.PermitLicenseModel = PermitLicenseModel;
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicenseModel.prototype, "p", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicenseModel.prototype, "ApproveDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicenseModel.prototype, "IsApproveEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicenseModel.prototype, "RefuseDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicenseModel.prototype, "IsRefuseEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicenseModel.prototype, "CancelDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicenseModel.prototype, "IsCancelEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicenseModel.prototype, "ApprovalCheckListItems", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicenseModel.prototype, "AreAllApprovalConditionsChecked", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicenseModel.prototype, "AdditionalConditions", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicenseModel.prototype, "CanUserCaptureApprovalConditions", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicenseModel.prototype, "CanUserCaptureApprovalComment", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], PermitLicenseModel.prototype, "ActiveLicenseStatus", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicenseModel.prototype, "loadLicenseItems", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicenseModel.prototype, "updateLicenseItems", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicenseModel.prototype, "updateLicenseItemApplicability", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicenseModel.prototype, "deriveIfAllApprovalConditionsAreChecked", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicenseModel.prototype, "approve", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicenseModel.prototype, "refuse", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicenseModel.prototype, "cancel", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicenseModel.prototype, "deriveApprovalState", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicenseModel.prototype, "deriveRefuseState", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicenseModel.prototype, "deriveCancelState", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicenseModel.prototype, "derivePermittedApprovalActions", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicenseModel.prototype, "restoreToOriginalStatus", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicenseModel.prototype, "setLicenseStatus", null);
});
